import { AddButton } from '#app/components/AddButton/AddButton.js';
import { SocialMediaLinkWithTooltip } from '#app/components/SocialMediaLink/SocialMediaLinkWithTooltip.js';
import { useAnalytics } from '#app/hooks/useAnalytics.js';
import {
  AddLinkText,
  EditIconButton,
  SidebarEditContainer,
} from './EditSocialLinks.styles.js';
import { type LinksToEdit } from './types.js';
import { EditIcon } from '@contra/icons/icons';

export const EditSocialLinks = ({
  isEditingAll,
  openAddLinks,
  socialLinks,
  visitorCanEdit,
}: {
  readonly isAddLinksOpen: boolean;
  readonly isEditingAll: boolean;
  readonly openAddLinks: () => void;
  readonly socialLinks: LinksToEdit;
  readonly visitorCanEdit: boolean;
}) => {
  const { track } = useAnalytics();

  const isEditable = visitorCanEdit && socialLinks.length > 0;

  return (
    <SidebarEditContainer>
      {socialLinks.map(({ id, label, url }, index) => (
        <SocialMediaLinkWithTooltip
          key={id}
          label={label}
          position={index}
          url={url}
          visitorCanEdit={Boolean(visitorCanEdit)}
        />
      ))}
      {isEditable && isEditingAll ? (
        <EditIconButton
          icon={EditIcon}
          iconSize={16}
          onClick={openAddLinks}
        />
      ) : null}
      {visitorCanEdit && socialLinks.length === 0 && !isEditingAll ? (
        <AddButton
          onClick={() => {
            track('button', {
              action: 'tapped',
              button_name: 'add_social_links_empty',
            });
            openAddLinks();
          }}
        >
          <AddLinkText>Add your social links</AddLinkText>
        </AddButton>
      ) : null}
    </SidebarEditContainer>
  );
};
